import { View } from "binder"
import { ColumnsEditorViewModelViewModel } from "./columnsEditorViewModel-viewModel"

export class ColumnsEditorViewModelView extends View<ColumnsEditorViewModelViewModel>{
    GetViewUniqueId(): string {
        return "V-FCF71354-5C2A-450C-8E2F-7A1DD4A82AB0"
    }
    loadHtml(): string {
        let element = require('./columnsEditorViewModel.html').default;
        let style = require('./columnsEditorViewModel.less');
        return element;
    }
    constructor() {
       super();
    }

    edit(){
        this.dataContext.edit();
    }
}
